import { z } from "zod";

export const masterExportInternalSchema = z.object({
  date: z.date().optional(),
  exchangeRates: z
    .object({
      sekConversion: z.number(),
      dkkConversion: z.number(),
      eurConversion: z.number(),
    })
    .optional(),
});

export type MasterExportInternal = z.infer<typeof masterExportInternalSchema>;
